var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { CommonActions, CommonSelectors, JourneysSelectors, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { createComponentsFromObject, CTA_TYPES, ExitIntentMobile as ExitIntentMobileContainer, } from 'conversional-components';
import { ENGINES, getItem, setItem } from 'conversional-persistent-storage';
import { exitIntentConfig } from 'conversional-environment';
import { OPEN } from './ExitIntentMobile.styles';
import * as CALL_TO_ACTIONS from '../constants/callToActions';
import { useListener, useRpcListener } from '../utils/listener';
var TIME_TO_LIVE = 86400000; // 1000ms * 60s * 24hours
var STORAGE_ENGINE = ENGINES.LOCAL_STORAGE;
var CTA_TYPE = CTA_TYPES.EXIT_INTENT_MOBILE;
/**
 * ExitIntentMobile View
 * appears once
 * permanently remebers its previous show state
 **/
var ExitIntentMobile = function (_a) {
    var onApplyStyles = _a.onApplyStyles, _b = _a.bodyStylesOpen, bodyStylesOpen = _b === void 0 ? {} : _b, _c = _a.bodyStylesClosed, bodyStylesClosed = _c === void 0 ? {} : _c, Children = _a.Children, exitIntentProps = __rest(_a, ["onApplyStyles", "bodyStylesOpen", "bodyStylesClosed", "Children"]);
    var dispatch = useAppDispatch();
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var activeCTA = useAppSelector(CommonSelectors.selectActiveCTA);
    var isOtherCTAActive = function () { return activeCTA && activeCTA !== CTA_TYPE; };
    var destroy = function () {
        if (bodyStylesClosed)
            sendToHost.styleParentBody(bodyStylesClosed);
        sendToHost.destroy();
        dispatch(CommonActions.broadcastSharedStoreChange({
            activeCTA: null,
        }));
        setItem(exitIntentConfig.HIDE_FLAG, 'true', { ttl: TIME_TO_LIVE }, STORAGE_ENGINE);
    };
    useListener(MESSAGETYPES.JOURNEY_SHOW_ENTRY, destroy);
    useListener(MESSAGETYPES.JOURNEY_SHOW_RESULT, destroy);
    useRpcListener(MESSAGETYPES.RPC_DISABLE_EXIT_INTENT, function () {
        window.exitIntentDisabled = true;
        onHide();
    });
    useRpcListener(MESSAGETYPES.RPC_ENABLE_EXIT_INTENT, function () { return (window.exitIntentDisabled = false); });
    React.useEffect(function () {
        if (hideExitIntent()) {
            destroy();
        }
    }, []);
    var onTrigger = function () {
        if (hideExitIntent() || window.exitIntentDisabled || isOtherCTAActive()) {
            return;
        }
        dispatch(CommonActions.broadcastSharedStoreChange({
            activeCTA: CTA_TYPE,
        }));
        setItem(exitIntentConfig.HIDE_FLAG, 'true', { ttl: TIME_TO_LIVE }, STORAGE_ENGINE);
        sendToHost.styleIframe(OPEN, true);
        if (bodyStylesOpen)
            sendToHost.styleParentBody(bodyStylesOpen);
        onApplyStyles();
    };
    var onClick = function () {
        dispatch(CommonActions.logCta(CALL_TO_ACTIONS.EXIT_INTENT_MOBILE));
        sendToHost.publish(MESSAGETYPES.JOURNEY_SHOW); // Can be made more flexible by adding journeyId as parameter
    };
    var onHide = function () {
        destroy();
    };
    var hideExitIntent = function () {
        return getItem(exitIntentConfig.HIDE_FLAG, {}, STORAGE_ENGINE) === 'true';
    };
    return (_jsx(ExitIntentMobileContainer, __assign({ onClose: onHide, onTrigger: onTrigger, onClick: onClick }, exitIntentProps, { children: Children && createComponentsFromObject(Children) })));
    // {createComponentsFromObject({root: exitIntentProps}, theme)}
};
export default ExitIntentMobile;
